export default "__VITE_ASSET__YA5ZWtxM__"